module.exports = __webpack_public_path__ + "static/media/CarouselRightArrowDisable.80fef9c1.svg";